/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_CrumbInputs */

const en_onboarding_crumb = /** @type {(inputs: Onboarding_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding`)
};

/**
* | output |
* | --- |
* | "Onboarding" |
*
* @param {Onboarding_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const onboarding_crumb = /** @type {((inputs?: Onboarding_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_onboarding_crumb(inputs)
});